<script>
import BaseResource from '@/resources'

export default {
    components: {},
    props: {
        value: {
            type: [BaseResource, Array],
            default() {
                return undefined
            }
        },
        resourceClass: {
            type: Function,
            required: true
        },
        handler: {
            type: Function,
            default: null
        },
        handlerOptions: {
            type: Object,
            default() {
                return {}
            }
        },
        placeholder: {
            type: String,
            default: 'Please select an option'
        },
        multiple: Boolean
    },
    data() {
        return {
            loading: true,
            selected: this.value,
            resourceOptions: []
        }
    },
    watch: {
        selected() {
            this.$emit('input', this.selected)
        },
        value(value) {
            this.selected = value
        }
    },
    methods: {
        async getObjects() {
            let ResourceClass = this.resourceClass
            let handlerFn = (this.handler) ? ResourceClass[this.hander].bind(ResourceClass) : ResourceClass.all.bind(ResourceClass)
            this.resourceOptions = await handlerFn(this.handlerOptions)
        }
    },
    async mounted() {
        const ResourceClass = this.resourceClass
        this.resourceOptions = await ResourceClass.all()
        this.loading = false
    },
}
</script>

<template>
    <div>
        <b-form-select v-model="selected" :multiple="multiple">
            <b-form-select-option v-if="!multiple" :value="undefined">{{ placeholder }}</b-form-select-option>
            <b-form-select-option v-for="(resource, i) in resourceOptions" :key="i" :value="resource">{{ resource }}</b-form-select-option>
        </b-form-select>
    </div>
</template>

<style lang="scss">
</style>
